const btResident = document.querySelector('#experts-resident')
const btAssocie =  document.querySelector('#experts-associe')
let zoneExperts = null
let allResident = null
let allAssocie = null
let allExperts = null


export const init = function () {

    // Vérifier s'il existe des bloc-expert
    if (document.querySelector('.bloc-expert')){
        initFormType()
    }
    
    // Vérifier s'il existe une navigation thématiques
    if (document.querySelector('.navigation-thematiques-experts')){
        zoneExperts = document.querySelector('.zone-experts')
        initFormTheme()
    }
    
}


const initFormTheme = function () { 

    allExperts = zoneExperts.querySelectorAll('.bloc-expert')
    const navThemes = document.querySelectorAll('.navigation-thematiques-experts li')

    const select = document.querySelector('.navigation-thematiques-experts select')

    select.addEventListener('change', function(e){
        afficheExperts(select.value)
    })

    navThemes.forEach(element => {
        element.addEventListener('click', function(e){
            e.preventDefault()
            navThemes.forEach(navTheme => {
                navTheme.classList.remove('is-active')
            });
            e.target.parentElement.classList.add('is-active')

            afficheExperts(e.target.dataset.themes)
 
        })
    });
}


const afficheExperts = function (t) {
    if (t == "all") {
        allExperts.forEach(expert => {
            expert.classList.add('is-active')
        });
    } else {
        var themes = Object.values(JSON.parse( t ))
        allExperts.forEach(expert => {
            var themesExpert = Object.values(JSON.parse( expert.dataset.themes )) 
            var intersections = themes.filter(e => themesExpert.indexOf(e) !== -1);
            if (intersections.length>0) {
                expert.classList.add('is-active')
                console.log(intersections,expert.dataset.id)
            } else {
                expert.classList.remove('is-active')
            }
        });
    }
}

const initFormType = function () {
    allResident = document.querySelectorAll('.bloc-expert[data-expert-type="resident"]')
    allAssocie = document.querySelectorAll('.bloc-expert[data-expert-type="associe"]')

    const zoneForm = document.querySelector('.navigation-experts');
    if (!zoneForm) return false;

    // Vérifier qu'il y a un choix possible
    const allExperts = document.querySelectorAll('.bloc-expert');
    let associe = 0
    let resident = 0
    allExperts.forEach(element => {
        if (element.dataset.expertType == 'associe') associe++
        else if (element.dataset.expertType == 'resident') resident++
    });

    if ( (resident>0) && (associe>0) ) zoneForm.style.display = 'block'
    else  zoneForm.style.display = 'none'


    btResident.addEventListener('click', function(e){
        testCheck()
    })

    btAssocie.addEventListener('click', function(e){
        testCheck()
    })

}

const testCheck = function () {
    if ( (btResident.checked && btAssocie.checked   ) || ( !btResident.checked && !btAssocie.checked   ) ) {
        associeCheck(true)
        residentCheck(true)
    } else {
        residentCheck(btResident.checked)
        associeCheck(btAssocie.checked)
    }
}

const associeCheck = function(check = true) {
    allAssocie.forEach(element => {
            if (check) element.classList.add('is-active-type')
            else element.classList.remove('is-active-type')
    });
}

const residentCheck = function(check = true) {
    allResident.forEach(element => {
        if (check) element.classList.add('is-active-type')
        else element.classList.remove('is-active-type')
    });
}
